import {IStoryService} from './IStoryService';
import {IStoryRepository} from './IStoryRepository';
import {
  CreateStoryInput,
  UpdateStoryInput,
  Story,
  GetStoriesResponse,
  PaginationInput,
  StoryFiltersInput,
} from '@PikaDoApp/npm-pikado-logic/dist/modules/story/graphql/story.interface';
import {
  AddChapterToStoryInput,
  Chapter,
  UpdateChapterInput,
} from '@PikaDoApp/npm-pikado-logic/dist/modules/storyChapter/graphql/storyChapter.interface';

export class StoryService implements IStoryService {
  constructor(private repo: IStoryRepository) {}

  async createStory(input: CreateStoryInput): Promise<Story> {
    return this.repo.createStory(input);
  }

  async updateStory(input: UpdateStoryInput): Promise<Story> {
    return this.repo.updateStory(input);
  }

  async deleteStory(id: string): Promise<boolean> {
    return this.repo.deleteStory(id);
  }

  async getStoryById(id: string): Promise<Story | null> {
    return this.repo.getStoryById(id);
  }

  async getStories(
    pagination?: PaginationInput,
    filters?: StoryFiltersInput,
  ): Promise<GetStoriesResponse | null> {
    return this.repo.getStories(pagination, filters);
  }

  async publishStory(id: string): Promise<Story> {
    return this.repo.publishStory(id);
  }

  async unpublishStory(id: string): Promise<Story> {
    return this.repo.unpublishStory(id);
  }

  async addChapterToStory(input: AddChapterToStoryInput): Promise<Chapter> {
    return this.repo.addChapterToStory(input);
  }

  async updateChapter(input: UpdateChapterInput): Promise<Chapter> {
    return this.repo.updateChapter(input);
  }

  async deleteChapter(id: string): Promise<boolean> {
    return this.repo.deleteChapter(id);
  }
}
